export default __webpack_public_path__ + "static/media/help-illustration01.990afeb4.svg";